/*
 * OriginalTextHover Messages
 *
 * This contains all the text for the OriginalTextHover component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.OriginalTextHover';

export default defineMessages({
  originalText: {
    id: `${scope}.originalText`,
    defaultMessage: 'Original text:',
  },
});
